import classnames from 'classnames';
import React from 'react';
import styles from './Image.module.scss';
import Element, { CommonProps } from '../Element/Element';

type ImageProps = {
  src: string;
  /** alt text */
  alt: string;
  /** mobile resolution source */
  mobileSrc?: string;
  /** Breakpoint after which mobileSrc is used (in px) */
  breakPoint?: number;
  /** Additional classes. */
} & CommonProps<'picture'>;

export const Image: React.FunctionComponent<ImageProps> = ({
  src,
  alt,
  mobileSrc,
  className,
  breakPoint,
  ...props
}) => {
  const classNames = [styles.image, className];
  return (
    <Element tagName="picture" block {...props}>
      <source
        media={breakPoint ? `(max-width: ${breakPoint}px)` : undefined}
        srcSet={mobileSrc}
      ></source>
      <img
        src={src}
        alt={alt}
        className={classnames(classNames)}
        {...props}
      ></img>
    </Element>
  );
};

export default Image;
